/**
 * Parse an API timestamp string into a Date object for chart rendering.
 *
 * @param {string} timestamp - ISO-8601 string (with or without timezone suffix)
 * @param {'hourly'|'daily'} mode - Bucket granularity.
 *   'hourly' keeps full datetime; 'daily' strips time/tz to avoid off-by-one shifts.
 * @returns {Date} Parsed Date (local timezone for daily, UTC-based for hourly)
 */
export default function parseChartTimestamp(timestamp, mode = 'daily') {
  if (!timestamp || typeof timestamp !== 'string') {
    return new Date(NaN); // invalid but won't crash downstream
  }

  if (mode === 'hourly') {
    return new Date(timestamp);
  }

  // Daily mode: parse only the date portion so timezone offsets don't shift the day.
  const datePart = timestamp.split('T')[0]; // "2025-10-07"
  const parts = datePart.split('-').map(Number);
  if (parts.length < 3 || parts.some(Number.isNaN)) {
    return new Date(NaN);
  }
  const [year, month, day] = parts;
  return new Date(year, month - 1, day); // local midnight, no tz shift
}
